import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const DEFAULT = { name: "Toko Saya", address: "", whatsapp: "" };
const StoreContext = createContext({ store: DEFAULT, setStore: () => {} });

export const StoreProvider = ({ children }) => {
  const [store, setStore] = useState(DEFAULT);

  useEffect(() => {
    api.get("/settings").then((r) => setStore(r.data)).catch(() => {});
  }, []);

  return <StoreContext.Provider value={{ store, setStore }}>{children}</StoreContext.Provider>;
};

export const useStore = () => useContext(StoreContext);
